import env from "config/env";
import { post } from "./http";
import { loginParams } from "./types";
import { JwtLoginSuccessResponse } from "features/types";
const BASE = "auth";

class AuthService {
  login(params: loginParams) {
    return post({
      url: `${BASE}/login`,
      params,
      config: {
        baseUrl: env.apiUrl.replace("tenantSubdomain", "fanrally"),
      },
    }) as Promise<JwtLoginSuccessResponse>;
  }

  logout() {
    return post({
      url: `${BASE}/logout`,
    }) as Promise<JwtLoginSuccessResponse>;
  }
}

export default new AuthService();
